import NavigationListItem from "@components/side-navbar/NavigationListItem";
import { PATHS } from "@constants/Paths";
import { Settings as SettingsIcon } from "@piiqtechnologies/svg-icons";
import React from "react";
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import messages from "./messages.i18n";
export const Settings = ({ expanded }) => {
    const intl = useIntl();
    return (React.createElement(NavLink, { to: `${PATHS.USER_SETTINGS}/${PATHS.USER_SETTINGS_PROFILE}`, style: { textDecoration: "none" } }, ({ isActive }) => (React.createElement(NavigationListItem, { Icon: () => React.createElement(SettingsIcon, { width: "20px", height: "20px" }), label: intl.formatMessage(messages.settings), expanded: expanded, active: isActive }))));
};
export default Settings;
